module.exports = require("@mui/material/StepLabel");